import React from "react";
import styles from "./DatabaseDetail.module.scss";
import { SonicProjectData } from "../../../../common/classes/SonicProject";
import { timestampToTime } from "../../../../utils/GeneralUtils";

type Props = {
  project: SonicProjectData;
};
const ProjectDetailInfo: React.FC<Props> = ({ project }) => {
  return (
    <>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>
          プロジェクト名
        </span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {project.name}
        </div>
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>
          プロジェクトカテゴリ
        </span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {project.type?.name}
        </div>
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>
          ゲームタイトル
        </span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {project.game && project.game.length > 0
            ? project.game.map((el) => el.name).join(`\n`)
            : "未選択"}
        </div>
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        {project.imgs && (
          <>
            <span className={styles["f-databaseDetail__info-title"]}>
              プロジェクトイメージ画像
            </span>
            <div className={styles["f-databaseDetail__info-content"]}>
              <div>
                {project.imgs.map((img) => (
                  <div className={styles["imageBox"]} key={img.id}>
                    <img src={img.medium.url} />
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>掲載期間</span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {`${
            project.start_date
              ? timestampToTime(project.start_date, false, false)
              : null
          } - ${
            project.end_date
              ? timestampToTime(project.end_date, false, false)
              : null
          }`}
        </div>
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>
          プロジェクト概要
        </span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {project.description}
        </div>
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>募集概要</span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {project.requirements}
        </div>
      </div>
      <div className={styles["f-databaseDetail__info"]}>
        <span className={styles["f-databaseDetail__info-title"]}>
          応募者への質問・確認事項
        </span>
        <div className={styles["f-databaseDetail__info-content"]}>
          {project.confirmations}
        </div>
      </div>
    </>
  );
};

export default ProjectDetailInfo;
